import React from 'react';
import langConf from "../js/lang";

class LanguageDropdown extends React.Component {
    state ={currentLanguage: this.props.lang}
    handleSelection = (event) =>{
        this.props.changeLanguage(event.target.value);
        this.setState({currentLanguage: event.target.value});
    };

    render () {
        let lang = this.props.lang;

        // Default sizes
        //console.log('window.innerWidth: ', window.innerWidth);
        if (window.innerWidth >= 0 && window.innerWidth <= 480) {// Small phones: form 0px to 480px 
            return (
                <div className={`choose-language ${lang==='hebrew'?'hebrew':'english'}`} style={lang === 'hebrew' ? {marginTop: '1px', marginRight: '2%', float: 'right'} : {paddingTop: '1px', marginLeft: '2%', float: 'left'}}>
                    <select className="ui dropdown" onChange={this.handleSelection} value={this.state.currentLanguage}>
                        <option value={'hebrew'}>{langConf[lang].hebrew}</option>
                        <option value={'english'}>{langConf[lang].english} </option>
                    </select>
                </div>
            );
        }
        else if (window.innerWidth >= 481 && window.innerWidth <= 767) {// Small phones to small tablets: form 481px to 767px 
            return (
                <div className={`choose-language ${lang==='hebrew'?'hebrew':'english'}`} style={lang === 'hebrew' ? {paddingTop: '10px', marginRight: '50px', float: 'right'} : {paddingTop: '10px', marginLeft: '50px', float: 'left'}}>
                    <select className="ui dropdown" onChange={this.handleSelection} value={this.state.currentLanguage}>
                        <option value={'hebrew'}>{langConf[lang].hebrew}</option>
                        <option value={'english'}>{langConf[lang].english} </option>
                    </select>
                </div>
            );
        }
        else if (window.innerWidth >= 768 && window.innerWidth <= 1023) {// Small tablets to big tablets: form 768px to 1023px
            return (
                <div className={`choose-language ${lang==='hebrew'?'hebrew':'english'}`} style={lang === 'hebrew' ? {paddingTop: '10px', marginRight: '50px', float: 'right'} : {paddingTop: '10px', marginLeft: '50px', float: 'left'}}>
                    <select className="ui dropdown" onChange={this.handleSelection} value={this.state.currentLanguage}>
                        <option value={'hebrew'}>{langConf[lang].hebrew}</option>
                        <option value={'english'}>{langConf[lang].english} </option>
                    </select>
                </div>
            );
        }
        else if (window.innerWidth <= 1200) {// Big tablets to 1200px (widths smaller than the 1140px row) 
            return (
                <div className={`choose-language ${lang==='hebrew'?'hebrew':'english'}`} style={lang === 'hebrew' ? {paddingTop: '10px', marginRight: '50px', float: 'right'} : {paddingTop: '10px', marginLeft: '50px', float: 'left'}}>
                    <select className="ui dropdown" onChange={this.handleSelection} value={this.state.currentLanguage}>
                        <option value={'hebrew'}>{langConf[lang].hebrew}</option>
                        <option value={'english'}>{langConf[lang].english} </option>
                    </select>
                </div>
            );
        }
        else {
        return (
            <div className={`choose-language ${lang==='hebrew'?'hebrew':'english'}`} style={lang === 'hebrew' ? {paddingTop: '10px', marginRight: '50px', float: 'right'} : {paddingTop: '10px', marginLeft: '50px', float: 'left'}}>
                <select className="ui dropdown" onChange={this.handleSelection} value={this.state.currentLanguage}>
                    <option value={'hebrew'}>{langConf[lang].hebrew}</option>
                    <option value={'english'}>{langConf[lang].english} </option>
                </select>
            </div>
        );
        }
    }
}

export default LanguageDropdown;